import { internationalReadinessSchema } from "@redotech/redo-return-core-common/international-readiness";
import * as z from "zod";

/** International readiness counting only the newest products, cheap enough to
 * check on every session. */
export const getCappedInternationalReadiness = {
  name: "getCappedInternationalReadiness" as const,
  input: z.null(),
  output: internationalReadinessSchema,
};
